<script setup lang="ts">
import { z } from 'zod'
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import { nextTick, onMounted, watch } from 'vue'

const emit = defineEmits<{
  submit: [values: AnyRecord]
  change: [values: AnyRecord]
}>()

defineSlots<{
  default: () => Any
}>()

const props = defineProps<{
  resolver?: AnyRecord
  initialValues?: AnyRecord
}>()

const formContext = useForm({
  validateOnMount: false,
  initialValues: props.initialValues,
  validationSchema: props.resolver ? toTypedSchema(z.object(props.resolver)) : undefined,
})

const formSubmit = formContext.handleSubmit((_, { controlledValues }) =>
  emit('submit', controlledValues),
)

onMounted(() => {
  nextTick(() => {
    watch(formContext.values, (nValues) => {
      emit('change', nValues)
    })
  })
})

defineExpose(formContext)
</script>

<template>
  <form @submit="formSubmit">
    <slot />
  </form>
</template>
